import { DefaultError, useMutation } from '@tanstack/react-query';
import { updateTodayGoalTaskOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateTodayGoalTaskOrderMutation = () =>
  useMutation<void, DefaultError, { goalId: ID; taskIds: ID[] }[]>({
    mutationFn: async (goalSorting) => updateTodayGoalTaskOrder(goalSorting),
  });
